import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import md5 from "md5";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage, WEB_SERVICE_MIMS } from "../../config/constants";
import { passwordValidation } from "../../config/functions";
// Components
import {
  ChangePasswordForm,
  TitleTextDiv,
  TextDiv,
  TitleP,
  TextP,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  SaveDiv,
  SaveButton,
} from "./styles";
import Axios from "../../config/axios";

const Settings = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    if (currentPassword === "" || newPassword === "" || confirmPassword === "") {
      return toast.error(t("settings.passwordSection.emptyFieldsMessage"));
    }
    if (!passwordValidation(newPassword)) {
      return toast.error(t("settings.passwordSection.passwordValidationMessage"));
    }
    if (newPassword !== confirmPassword) {
      return toast.error(t("settings.passwordSection.confirmPasswordMessage"));
    }
    Axios("post", `${WEB_SERVICE_MIMS}/clinicians/update-password/${clinicianData.CLINICIAN_ID}`, {
      currentPassword: md5(`${clinicianData.CLINICIAN_USER}${currentPassword}`),
      newPassword: md5(`${clinicianData.CLINICIAN_USER}${newPassword}`),
    })
      .then(({ data }) => {
        if (data.incorrectPassword) {
          return toast.error(t("settings.passwordSection.incorrectPasswordMessage"));
        }
        if (data.passwordUpdated) {
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          toast.success(t("settings.passwordSection.passwordUpdatedMessage"));
          setRedirect(true);
        }
      })
      .catch((error) => {
        console.log("url error: ", error);
        return toast.error(t("settings.passwordSection.sendDataErrorMessage"));
      });
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}/home/${clinicianData.token}`} />;
  }

  return (
    <>
      <ChangePasswordForm>
        <TitleTextDiv>
          <TitleP>{t("settings.passwordSection.title")}</TitleP>
        </TitleTextDiv>
        <TextDiv>
          <TextP>{t("firstLogin.confirmChangeText")}</TextP>
        </TextDiv>
        <DataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="currentPassword" fontWeight="bold">
                {t("settings.passwordSection.currentPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="newPassword" fontWeight="bold">
                {t("settings.passwordSection.newPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="confirmPassword" fontWeight="bold">
                {t("settings.passwordSection.confirmNewPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </InputDataDiv>
          </ColumnDataDiv>
        </DataDiv>
        <SaveDiv>
          <SaveButton onClick={handleUpdatePassword}>{t("settings.passwordSection.saveButton")}</SaveButton>
        </SaveDiv>
      </ChangePasswordForm>
    </>
  );
};

export default Settings;
